module.exports = __webpack_public_path__ + "static/media/arrow_right.b12dee69.svg";